const item = state => state.item
const status = state => state.status
const removables = state => state.removables

export default {
  item,
  status,
  removables
}
